import { randomJitter } from "@ndn/util";
/** Construct RetxGenerator from RetxPolicy. */
export function makeRetxGenerator(policy) {
    if (!policy) { // applies to both `undefined` and zero
        return () => [];
    }
    if (typeof policy === "function") {
        return policy;
    }
    if (typeof policy === "number") {
        policy = { limit: policy };
    }
    return function* (interestLifetime) {
        const { limit = 0, interval = interestLifetime * 0.5, randomize = 0.1, backoff = 1, max = interestLifetime * 0.9, } = policy;
        const jitter = randomJitter(randomize);
        let nextInterval = interval;
        for (let i = 0; i < limit; ++i) {
            yield nextInterval * jitter();
            nextInterval = Math.min(nextInterval * backoff, max);
        }
    };
}
